import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function LandingPageCard({ title, subtitle, icon, onClick }) {
    const { i18n } = useTranslation();

    return (
        <div
            style={{
                border: "1px solid #E57200",   
                borderRadius: "1rem"          
            }}
            onClick={onClick}
            className="rounded-2xl   bg-white w-full sm:w-1/2 self-center mt-2 flex flex-row justify-between items-center px-4 py-3 cursor-pointer hover:bg-gray-50 transition"
        >
            <div className="flex flex-row gap-2.5 items-center">
                <img src={icon} alt="menu icon" className="w-6 h-6" />
                <div className="flex flex-col gap-0.5">
                    <div className="text-stone-700 text-base font-semibold font-cairo leading-normal">
                        {title}
                    </div>
                    <div className="text-zinc-500 text-sm font-normal font-cairo leading-tight">
                        {subtitle}
                    </div>
                </div>
            </div>
            {i18n.language === "en" ? (
                <AiOutlineRight className="text-[#E57200] w-5 h-5" />
            ) : (
                <AiOutlineLeft className="text-[#E57200] w-5 h-5" />
            )}
        </div>
    );
}
